import React from "react";
import PropTypes from "prop-types";

const TabBarItem = ({children, label, navIcon, navIconSize, activeTab, isVisible, ...attrs}) => {

    const style = {
        display: "none"
    }

    if (activeTab === label) {
        style.display = "block"
    }

    return (
        isVisible &&
        <div style={style} {...attrs}>
            {children}
        </div>
    )
}

TabBarItem.propTypes = {
    label: PropTypes.string.isRequired,
    navIcon: PropTypes.string,
    navIconSize: PropTypes.number,
    children: PropTypes.node,
    activeTab: PropTypes.string
}

TabBarItem.defaultProps = {
    children: null,
    navIcon: 'align-justified',
    navIconSize: 14,
    activeTab: ''
}

export default TabBarItem;


// WEBPACK FOOTER //
// ./src/Components/Utils/VTabBar/TabBarItem.js